module.exports = __webpack_public_path__ + "media/images/top/top_pickup_company_09-6cb2201a8d7f6ca36a2de41dae32d225.png";